import { useCatalogue } from '../../../hooks/use-catalogue';
import { containerTypesApi } from '../container-types.api';

export const useContainerTypes = () => useCatalogue(containerTypesApi, { conflictMessage: 'A container type with this code already exists.' });
